import { createSlice } from "@reduxjs/toolkit";
import { fetchProducts, getProducts } from "../api/products";

const initialState = {
  products: [],
  total: 0,
  page: 1,
  totalPages: 0,
  allProducts: [],
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload.products;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.totalPages = action.payload.totalPages;
      state.allProducts = action.payload.allProducts;
    },
    setAllProducts: (state, action) => {
      state.allProducts = action.payload.products;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ fetchProducts — allProducts ke liye (app load pe)
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.allProducts = action.payload.data;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      // ✅ getProducts — paginated products ke liye
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.products;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { setProducts, setAllProducts } = productSlice.actions;
export default productSlice.reducer;